import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-strategy-vs-data-analytics',
  templateUrl: './data-strategy-vs-data-analytics.component.html',
  styleUrls: ['./data-strategy-vs-data-analytics.component.sass']
})
export class DataStrategyVsDataAnalyticsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
